import { useCurrentStore } from 'modules/Listings/store/useCurrentStore';
import { IconFilter } from 'components/Icons';
import { observer } from 'mobx-react-lite';
import { cx } from '@linaria/core';
import { textRegularLight } from 'styles/typography';
import { baseStyles, iconButton, regularButton } from './styles';

const ListFilterToggle_ = ({ buttonText }: { buttonText?: string }): JSX.Element => {
  const store = useCurrentStore();
  return (
    <button type="button" className={cx(baseStyles, buttonText ? regularButton : iconButton)} onClick={() => store.toggleShowFilter()}>
      <IconFilter size={16} color="#306AFF" />
      {buttonText && <span className={textRegularLight}>{buttonText}</span>}
    </button>
  );
};

export const ListFilterToggle = observer(ListFilterToggle_);
